<template>
  <div>
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :label="$t('uuid')"
            v-model="inferenceCameraItem._id"
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="channelData != null">
          <v-text-field
            v-model="channelData.channel_uuid"
            :label="$t('channel') + ' ' + $t('uuid').toLowerCase()"
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="channelData != null">
          <v-select
            v-model="channelData.list_type"
            :items="['None', ...listTypeItems]"
            :label="$t('list_type')"
          >
          </v-select>
        </v-col>

        <v-col cols="12" v-if="inferenceCameraItem.camera != undefined">
          <v-text-field
            :label="$t('camera') + ' ' + $t('uuid').toLowerCase()"
            v-model="inferenceCameraItem.camera.camera_id"
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="inferenceCameraItem.camera != undefined">
          <v-text-field
            :label="$t('camera') + ' ' + $t('name').toLowerCase()"
            v-model="inferenceCameraItem.camera.camera_name"
            disabled
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="inferenceCameraData != null">
          <v-text-field
            v-model="inferenceCameraData.camera_alias"
            :label="$t('camera') + ' ' + $t('alias').toLowerCase()"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="inferenceCameraData != null">
          <v-row v-if="inferenceCameraData != null">
            <!-- <v-col cols="6">
              <v-slider
                v-model="inferenceCameraData.fps"
                :label="$t('fps')"
                step="1"
                min="1"
                max="3"
                thumb-label
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="inferenceCameraData.fps"
                    class="mt-0 pt-0"
                    type="number"
                    step="1"
                    min="1"
                    max="3"
                  >
                  </v-text-field>
                </template>
              </v-slider>
            </v-col> -->

            <v-col cols="12">
              <v-slider
                v-model="inferenceCameraData.track_limit"
                :label="$t('track_limit')"
                step="1"
                min="1"
                max="3"
                track-color="grey"
                thumb-label
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="inferenceCameraData.track_limit"
                    class="mt-0 pt-0"
                    type="number"
                    step="1"
                    min="1"
                    max="3"
                  >
                  </v-text-field>
                </template>
              </v-slider>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-btn color="primary" @click="updateInferenceCamera">{{
            $t("update")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import {
  getInferenceCameras,
  updateInferenceCamera,
} from "@/endpoint/inferenceCamera";

import { getChannels, updateChannel } from "@/endpoint/channel";

export default {
  name: "InferenceInference",
  data() {
    return {
      inferenceCameraData: null,
      channelData: null,
      channelTable: null,
      inferenceCameraItem: {},
      inferenceCameraItems: [],
      listTypeItems: ["whitelist", "blacklist", "VIP"],
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    async init(scope) {
      const inference_camera_uuid = scope.$route.params.uuid;

      scope.inferenceCameraItems = await getInferenceCameras();

      scope.inferenceCameraItem = scope.inferenceCameraItems.find((item) => {
        return item._id == inference_camera_uuid;
      });

      scope.inferenceCameraData = JSON.parse(
        JSON.stringify(scope.inferenceCameraItem)
      );

      scope.channelTable = await getChannels();

      scope.channelData = Object.values(scope.channelTable).find(
        (value) => value.inference_camera_uuid == this.inferenceCameraItem._id
      );

      return scope;
    },
    updateInferenceCamera() {
      let data = new FormData();

      data.append("_id", this.inferenceCameraData._id);
      data.append("camera_alias", this.inferenceCameraData.camera_alias);
      data.append("fps", this.inferenceCameraData.fps);
      data.append("track_limit", this.inferenceCameraData.track_limit);

      updateInferenceCamera(data).then(() => {
        data = {};
        data.list_type = this.channelData.list_type;
        updateChannel(this.channelData.channel_uuid, data).then(() => {
          this.$router.go();
        });
      });
    },
  },
};
</script>